import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import EraseAllButton from "../components/EraseAllButton";
import { api } from "../lib/api";
import { Loader2, ChevronRight, RefreshCcw } from "lucide-react";

function fmtDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
  } catch { return iso; }
}

export default function TransactionsHub() {
  const nav = useNavigate();
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const r = await api.get("/admin/sales"); setSales(r.data); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <Layout>
      <div className="max-w-6xl mx-auto px-6 py-10">
        <button onClick={() => nav("/pos/dashboard")} className="label-eyebrow mb-6 inline-block" data-testid="tx-back">← Back</button>
        <div className="flex items-end justify-between mb-8 flex-wrap gap-3">
          <h1 className="font-display text-4xl font-black">Transactions</h1>
          <div className="flex gap-2">
            <button onClick={load} className="btn-secondary inline-flex items-center gap-2" data-testid="tx-refresh"><RefreshCcw size={14} /> Refresh</button>
            <EraseAllButton scope="transactions" label="Erase All Transactions" confirmText="every transaction record and its member purchase history" onDone={load} testid="tx-erase-all" />
          </div>
        </div>

        {loading ? <Loader2 className="animate-spin" /> : sales.length === 0 ? (
          <div className="surface p-6 text-sm" style={{ color: "var(--ab-text-muted)" }} data-testid="tx-empty">No transactions yet.</div>
        ) : (
          <div className="surface divide-y" style={{ borderColor: "var(--ab-border)" }}>
            {sales.map((s) => {
              const refunded = s.fully_refunded;
              const partial = !refunded && (s.refunded_subtotal || 0) > 0;
              return (
                <Link key={s.id} to={`/pos/transactions/${s.id}`} className="flex items-center px-5 py-4 hover:bg-[var(--ab-surface-2)] transition-colors gap-3" data-testid={`tx-row-${s.id}`}>
                  <div className="flex-1 min-w-0">
                    <div className="font-bold truncate">
                      {s.member_name}
                      {s.member_phone && <span className="font-mono text-xs ml-2" style={{ color: "var(--ab-text-dim)" }}>#{s.member_phone}</span>}
                    </div>
                    <div className="text-xs mt-1" style={{ color: "var(--ab-text-dim)" }}>
                      {fmtDate(s.completed_at)} · {s.items?.length || 0} item{(s.items?.length || 0) === 1 ? "" : "s"}
                    </div>
                  </div>
                  {refunded && <span className="text-[10px] uppercase tracking-widest px-2 py-1" style={{ color: "var(--ab-danger)", border: "1px solid var(--ab-danger)" }}>Refunded</span>}
                  {partial && <span className="text-[10px] uppercase tracking-widest px-2 py-1" style={{ color: "var(--ab-warning)", border: "1px solid var(--ab-warning)" }}>Partial Refund</span>}
                  <div className="text-right">
                    <div className="font-mono font-bold" style={{ color: "var(--ab-primary)" }}>${Number(s.total).toFixed(2)}</div>
                    {s.discount_amount > 0 && <div className="text-[10px]" style={{ color: "var(--ab-text-dim)" }}>−${Number(s.discount_amount).toFixed(2)} disc.</div>}
                  </div>
                  <ChevronRight size={16} style={{ color: "var(--ab-text-dim)" }} />
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </Layout>
  );
}
